<template>
  <component
    :is="pageComponent"
  />
</template>

<script setup lang="ts">
const dynamicPages = {
  '404': defineAsyncComponent(() => import('~layers/app/pages/~404.vue')),
  'plp': defineAsyncComponent(() => import('~layers/app/pages/~plp.vue')),
  'pdp': defineAsyncComponent(() => import('~layers/app/pages/~pdp.vue')),
  'pdp-ad-variant': defineAsyncComponent(() => import('~layers/app/pages/~pdp-ad-variant.vue')),
  'cms': defineAsyncComponent(() => import('~layers/app/pages/~cms.vue')),
  'customer-service': defineAsyncComponent(() => import('~layers/app/pages/~customer-service.vue')),
  'blog-overview': defineAsyncComponent(() => import('~layers/app/pages/~blog-overview.vue')),
  'blog-detail': defineAsyncComponent(() => import('~layers/app/pages/~blog-detail.vue')),
}

const typeToPageMapping = {
  'plp': 'plp',
  'plp-theme': 'plp',
  'plp-brand': 'plp',
  'plp-filter': 'plp',
  'plp-landing': 'cms',
  'pdp': 'pdp',
  'pdp-ad-variant': 'pdp-ad-variant',
  'cms-page': 'cms',
  'customer-service-page': 'customer-service',
  'blog-overview': 'blog-overview',
  'blog-detail': 'blog-detail',
}

const route = useRoute()
const { fetchRoute } = useCustomRouter()
const { fetchRedirect } = useCustomRouterRedirect()

const esUrlPath = computed(() => route.path.replace(/^\/+|\/+$/g, ''))
// console.log({ esUrlPath: esUrlPath.value })

const meta = await fetchRoute(route.path)
const { experiment, isVariant, group, trackExperiment } = useAbTest()
if (experiment.value == 'exp210045' && isVariant('B')) {
  const alternative = (meta.alternatives ?? []).find((a: { page_type: string }) => a.page_type == 'cms-page')
  if (alternative) {
    meta.page_type = alternative.page_type
    meta.strapi_id = alternative.strapi_id
    meta.robots = alternative.robots
  }
}
trackExperiment()
// console.log({ meta })

if (meta?.page_type === 'pdp-ad-variant' && experiment.value === 'exp209185' && group.value === 'A') {
  meta.page_type = 'pdp'
}

provide('meta', ref(meta))

// Resolve page/component to render
const page = computed(() => {
  return typeToPageMapping[meta?.page_type]
})

// Resolve page/component to render
const pageComponent = computed(() => {
  return dynamicPages?.[page.value] || dynamicPages?.['404']
})

const redirect = ref<{ code: number, url: string } | null>(null)

// No meta data, or unknown component, check for redirect
if (!meta || !page.value) {
  redirect.value = await fetchRedirect(esUrlPath.value)

  const { sanitizeUrl } = useSanitizeUrl()
  if (redirect.value?.url) {
    await navigateTo(sanitizeUrl(redirect.value?.url), {
      redirectCode: redirect.value?.code || 301,
    })
  }
}

// No redirect, render 404
if (!page.value && !redirect.value?.url) {
  // throw createError({
  //   statusCode: 404,
  //   message: 'Page Not Found',
  //   fatal: true,
  // })

  const event = useRequestEvent()

  if (event) {
    setResponseStatus(event, 404, 'Page Not Found')
  }
}
</script>
